import EmailSetting from './EmailSetting';

export default EmailSetting;



// WEBPACK FOOTER //
// ./src/app/views/admin/emailSetting/index.js